import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c006072"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "contact-base" }
const _hoisted_2 = { id: "contact-element" }
const _hoisted_3 = { id: "contact-left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Contact Us", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " If you have any concerns or questions don't hesitate to contact us. ", -1))
const _hoisted_6 = { class: "info-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "link",
  href: "mailto:general.ops@badtoadgames.com"
}, "general.ops@badtoadgames.com", -1))
const _hoisted_8 = { id: "contact-right" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Get in touch", -1))
const _hoisted_10 = { class: "flex-row" }
const _hoisted_11 = { class: "input-div" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Name", -1))
const _hoisted_13 = { class: "input-div" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Email", -1))
const _hoisted_15 = { class: "input-div" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Subject", -1))
const _hoisted_17 = { class: "input-div" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Message", -1))
const _hoisted_19 = { id: "messageLength" }
const _hoisted_20 = {
  key: 0,
  id: "signup-button",
  class: "locked-button"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_fa, {
            class: "paper-plane icon",
            icon: "paper-plane"
          }),
          _hoisted_7
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "",
                id: "",
                placeholder: "Name",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contents.name) = $event)),
                onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.checkValidInput && _ctx.checkValidInput(...args))),
                maxlength: "256"
              }, null, 544), [
                [_vModelText, _ctx.contents.name]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives(_createElementVNode("input", {
                type: "email",
                name: "",
                id: "",
                placeholder: "Email",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contents.email) = $event)),
                onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.checkValidInput && _ctx.checkValidInput(...args))),
                maxlength: "256"
              }, null, 544), [
                [_vModelText, _ctx.contents.email]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "",
              id: "",
              placeholder: "Subject",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.contents.subject) = $event)),
              onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.checkValidInput && _ctx.checkValidInput(...args))),
              maxlength: "256"
            }, null, 544), [
              [_vModelText, _ctx.contents.subject]
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _withDirectives(_createElementVNode("textarea", {
              name: "",
              id: "",
              cols: "30",
              rows: "5",
              placeholder: "Message",
              maxlength: "2000",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.contents.message) = $event)),
              onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.checkValidInput && _ctx.checkValidInput(...args)))
            }, "\n            ", 544), [
              [_vModelText, _ctx.contents.message]
            ]),
            _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.messageLength) + " / 2000 ", 1)
          ]),
          (_ctx.buttonLocked)
            ? (_openBlock(), _createElementBlock("button", _hoisted_20, " Locked "))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                id: "signup-button",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.signUp && _ctx.signUp(...args)))
              }, "Send"))
        ])
      ])
    ])
  ]))
}